import { useSiteContext, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { NavigationItemFragment } from 'src/graphql/generated/graphql-types'

const useCategoryPageMetadata = (
  seoTitle: string | null,
  seoMetaDescription: string | null,
  categoryName: string,
  path: NavigationItemFragment[]
) => {
  const { siteType } = useSiteContext()
  const { translate } = useTranslations()

  const isTopCategory = path.length === 1

  const getFallbackMetaDescription = () => {
    return isTopCategory
      ? translate(
          siteType === 'Consumer' ? 'Products_Metadescription_B2C' : 'Products_Metadescription_B2B'
        )
      : translate(
          siteType === 'Consumer' ? 'Category_MetaDescription_B2C' : 'Category_MetaDescription_B2B',
          {
            category: categoryName,
          }
        )
  }

  const getFallbackTitle = () => {
    return isTopCategory
      ? translate(siteType === 'Consumer' ? 'Products_Title_B2C' : 'Products_Title_B2B')
      : path
          .slice(1)
          .reverse()
          .map(p => p.category?.seoLongTitleName ?? p.category?.name)
          .filter(Boolean)
          .join(' - ')
  }

  return {
    title: seoTitle ?? getFallbackTitle(),
    metaDescription: seoMetaDescription ?? getFallbackMetaDescription(),
  }
}

export default useCategoryPageMetadata
